import React, { Component } from 'react';
import Dialog from 'material-ui/Dialog';
import { connect } from 'react-redux';
import { logoutAction as AgencyLogoutAction } from '../modules/logins/actions/LoginActions';
import { logoutAction as clientLogoutAction } from '../modules/PatientPortal/logins/actions/LoginActions';

class UpdatePasswordModal extends Component{
    constructor(props) {
      super(props);
        this.state ={
            open: true
        }
      };
     
      logout = () => {
        if(this.props.loginUserInfo && this.props.loginUserInfo.users3 && this.props.loginUserInfo.users3.userRoles.roleName === 'Client'){
          this.props.clientLogoutAction();
        }else{
          this.props.AgencyLogoutAction();
        }
      }
      
      render(){
        return (
          <Dialog open={this.state.open}>
           <p>Password Updated successfully, Please <span onClick={(e) => this.logout()} style={{cursor: 'pointer', color: 'blue'}}>Login</span > with new Password </p>
          </Dialog>
        )
      }
}

const mapStateToProps = (state) =>{
  
  return {
    loginUserInfo: state.login.loginUserInfo,
  }
}

export default connect(mapStateToProps,{AgencyLogoutAction,clientLogoutAction})(UpdatePasswordModal);


// WEBPACK FOOTER //
// ./src/components/updatePasswordModal.js